import { initReactI18next } from 'react-i18next'

import i18n from 'i18next'

import { detectLocale, getSiteLocaleCookie } from './lib/detect-locale'
import { syncDocumentLanguage } from './lib/intl/sync-document-language'
import { LOCAL_STORAGE_KEYS } from './lib/local-storage-keys'

// Precedence: the locale explicitly persisted in the app wins; otherwise honor
// the choice made on the marketing site (shared `.signater.com` cookie); fall
// back to the browser's language, then enUs.
const savedLanguage =
  (JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.LANGUAGE) || '{}').state
    ?.locale as string) ||
  getSiteLocaleCookie() ||
  detectLocale()

// Runs at module scope, before the first render, so the document never
// paints while `<html lang>` still claims the shell's hardcoded English.
syncDocumentLanguage(savedLanguage)

// Deliberate: our internal locale codes (enUs, ptBr, …) are not BCP47, so
// i18next's Intl.PluralRules lookup fails and every language falls back to
// the English rule (1 → _one, everything else → _other). All locale files
// only carry _one/_other keys, so this is uniform and predictable. Revisit
// (map to BCP47 at init) only if some language ever needs zero/few/many —
// note it would flip counts like pt-BR 0 to the singular form.
i18n.use(initReactI18next).init({
  lng: savedLanguage,
  fallbackLng: 'enUs',
  resources: {},
  interpolation: {
    escapeValue: false,
  },
})

export default i18n
